module.exports = __webpack_public_path__ + "img/psicologia-positiva-3.56055454.jpg";